import { render } from "./cjcx.vue?vue&type=template&id=12714315&scoped=true"
import script from "./cjcx.vue?vue&type=script&lang=js"
export * from "./cjcx.vue?vue&type=script&lang=js"

import "./cjcx.vue?vue&type=style&index=0&id=12714315&lang=scss&scoped=true"

import exportComponent from "/home/code/aiyu-before-pc/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12714315"]])

export default __exports__